(function ($) {
  const suffix = '%';
  const bypass = [9, 16, 17, 18, 36, 37, 38, 39, 40, 91, 92, 93];
  const elements = document.getElementsByClassName('percentage-mask');
  let nudgeData = {};
  let nudgeContent = $('.nudge-tool__content').html();

  function percentToInt(val) {
    let value = val.replace(/\D/g, '');
    return parseInt(value.replace(suffix, '')) || 0;
  }

  Array.from(elements).forEach(function (elm) {
    let tempVal = 0;
    const saveValue = function (data) {
      elm.dataset.value = data;
    };
    const focusNumber = function () {
      elm.setSelectionRange(elm.dataset.value.length, elm.dataset.value.length);
    };
    elm.addEventListener('input', function (e) {
      if (bypass.indexOf(e.keyCode) !== -1) return;

      const pure = percentToInt(elm.value);
      if (pure > 100) {
        elm.value = tempVal + suffix;
        return;
      }
      tempVal = pure;
      saveValue(pure);
      if (!pure) {
        elm.value = '0' + suffix;
        return;
      }
      elm.value = pure + suffix;
      focusNumber();
    });
  });

  $.fn.percentageCalculator = function (options) {
    // Default settings and options
    var settings = $.extend({
      suffix: '%',
      totalPercentageSelector: '',
      containerInfoSelector: '',
    }, options);

    var totalValue = 0;
    var $totalPercentage = $(settings.totalPercentageSelector);
    var $containerInfo = $(settings.containerInfoSelector);
    var calcId = $(this).data('calc-id');

    this.on('input', function () {
      totalValue = 0;

      $('[data-calc-id="' + calcId + '"]').each(function () {
        var $this = $(this);
        var val = $this.val() || 0;
        var pureVal = percentToInt(val);
        totalValue += pureVal;
      });

      if (totalValue === 0) {
        $containerInfo.removeClass('field-error');
        $containerInfo.stop(true).fadeOut(200);
        return;
      }

      $totalPercentage.text(totalValue + settings.suffix);

      $containerInfo.stop(true).fadeIn(200);

      if (totalValue !== 100) {
        $containerInfo.addClass('field-error');
      } else {
        $containerInfo.removeClass('field-error');
      }
    });

    return this;
  };

  function scaleToPercentage(max, value) {
    const scale = max / 100;
    return `${value / scale}%`;
  }

  function populateNudgeResult(type) {
    let htmlBar = '';
    let maxValue = -Infinity;

    for (const key in nudgeData) {
      const entry = nudgeData[key];
      if (entry[type] > maxValue) {
        maxValue = entry[type];
      }
    }

    for (const key of Object.keys(nudgeData)) {
      let bar = nudgeData[key];

      const dataWidth = scaleToPercentage(maxValue, bar[type]);
      htmlBar += `<div class="nudge-bar">
        <span class="nudge-bar-label">
          <span>${bar['product']}</span>
          <span>${bar['name']}</span>   
        </span>
        <div class="nudge-bar-wrapper">
          <div class="nudge-bar-line nudge-bar-line--${type}" data-width="${dataWidth}">
          </div>
          <span class="nudge-bar-point">${bar[type]}</span>
        </div>
      </div>`;
    }

    $('#nudgeChart').html(htmlBar);

    $('.nudge-bar-line').each(function () {
      var $this = $(this),
        width = $this.data('width');
      $this.animate({ width: width });
    });
  };

  function validateSelectFields() {
    var $selects = $('.select-validate');
    $selects.each(function () {
      var $this = $(this),
        val = $this.val();
      if (!val) {
        $this.parents('.field-group').addClass('field-error');
        if ($this.parents('.field-group').find('.error-message').length < 1) {
          $this.parents('.field-group').append('<p class="small-text error-message"><i>This field is required.</i></p>');
        }
      } else {
        $this.parent('.field-group').removeClass('field-error');
        $this.parents('.field-group').find('.error-message').remove();
      }
    });
  }

  function populateDonwloadData() {
    let totalHtml = '',
      tailoredHtml = '',
      labelHtml = '',
      maxTotal = -Infinity,
      maxTailored = -Infinity;

    for (const key in nudgeData) {
      const entry = nudgeData[key];
      if (entry.total > maxTotal) {
        maxTotal = entry.total;
      }
      if (entry.tailored > maxTailored) {
        maxTailored = entry.tailored;
      }
    }

    for (const key of Object.keys(nudgeData)) {
      const bar = nudgeData[key];

      const totalWidth = scaleToPercentage(maxTotal, bar['total']);
      const tailoredWidth = scaleToPercentage(maxTailored, bar['tailored']);

      labelHtml += `<div class="label-wrapper">
              <div>${bar['product']}</div>
              <div>${bar['name']}</div>                
            </div>`;

      totalHtml += `<div class="nudge-bar">
        <div class="nudge-bar-wrapper">
          <div class="nudge-bar-line nudge-bar-line--total" style="width: ${totalWidth};">
          </div>
          <span class="nudge-bar-point">${bar['total']}</span>
        </div>
      </div>`;

      tailoredHtml += `<div class="nudge-bar">
        <div class="nudge-bar-wrapper">
          <div class="nudge-bar-line nudge-bar-line--tailored" style="width: ${tailoredWidth};">
          </div>
          <span class="nudge-bar-point">${bar['tailored']}</span>
        </div>
      </div>`;
    }

    $('#nudgeDownloadLabel').html(labelHtml);
    $('#nudgeDownloadTotalChart').html(totalHtml);
    $('#nudgeDownloadTailoredChart').html(tailoredHtml);
  }

  $('.select-nudge').on('change', function () {
    var $this = $(this);

    if ($this.hasClass('select-validate')) {
      $this.parent().removeClass('field-error');
      $this.parents('.field-group').find('.error-message').remove();
    }
  });

  var isFormBusy = false;
  $('#FormNudge').on('submit', function (e) {
    e.preventDefault();

    var $this = $(this);

    validateSelectFields();

    if ($this.find('.field-error').length > 0 || isFormBusy) return;

    $this.find('.spinner').fadeIn(200);
    isFormBusy = true;

    let formData = {
      "funnel_stage": $this.find('[name="funnel_stage"]').val() || '',
      "category": $this.find('[name="category"]').val(),
      "channel": $this.find('[name="channel"]').val(),
      "product_type": $this.find('[name="product_type"]').val() || '',
      "age_profile": {},
      "gender_profile": {},
    };

    $this.find('.percentage-age').each(function () {
      var $input = $(this);

      formData['age_profile'][$input.attr('name')] = percentToInt($input.val());
      $('span[data-value="'+$input.attr('name')+'"').text($input.val());
    });

    $this.find('.percentage-gender').each(function () {
      var $input = $(this);

      formData['gender_profile'][$input.attr('name')] = percentToInt($input.val());
      $('span[data-value="'+$input.attr('name')+'"').text($input.val());
    });

    $.ajax({
      type: 'GET',
      url: wpfe.ajax_url,
      data: {
        nonce: wpfe.ajax_nonce,
        action: "nudge_tool_ajax",
        data: formData,
      },
      success: function (response) {
        nudgeData = response;

        window.scrollTo({ top: ($('.nudge-tool__form').offset().top - 120), behavior: 'smooth' });

        setTimeout(function () {
          $('.nudge-tool__form').fadeOut(100);
          $('.nudge-tool__result').fadeIn(150);

          $('.nudge-tool .pattern__playbook').fadeIn(150);
          $('.nudge-tool .pattern__base').fadeOut(100);

          $('.nudge-tool__content').html(`
            <h2 class="nudge-title">The most powerful nudges for your comms plan</h2>
            <p>See the results on the right for your <u>tailored</u> set of nudges that will be most impactful for your current situation and objectives. You can benchmark these results against the <u>overall</u> most powerful heuristics across all scenarios by clicking on the 'overall' option at the top too.</p>
          `);

          populateNudgeResult('tailored');

          populateDonwloadData();

          for (let key in formData) {
            if (formData[key]) {
              var val = $('option[value="'+formData[key]+'"]').text();
              $('span[data-value="'+key+'"').text(val);
              $('span[data-value="'+key+'"').parent().show();
            } else {
              $('span[data-value="'+key+'"').parent().hide();
            }
          }
        }, 100);
      },
      complete: function () {
        isFormBusy = false;
        $this.find('.spinner').fadeOut(200);
      }
    });
  });

  $('.percentage-age').percentageCalculator({
    suffix: suffix,
    totalPercentageSelector: '#ageTotalPercentage',
    containerInfoSelector: '#containerAgeInfo'
  });

  $('.percentage-gender').percentageCalculator({
    suffix: suffix,
    totalPercentageSelector: '#genderTotalPercentage',
    containerInfoSelector: '#containerGenderInfo'
  });

  $(document).on('click', '.nudge-tab-item', function (e) {
    e.preventDefault();

    if (!nudgeData) {
      return;
    }

    var $this = $(this),
      dataKey = $this.data('key');

    if ($this.hasClass('active')) return;

    $('.nudge-tab-item').removeClass('active');
    $this.addClass('active');

    populateNudgeResult(dataKey);
  });

  let isBusy = false;
  $(document).on('click', '.nudge-tool .btn-download', async function (e) {
    e.preventDefault();

    if (isBusy) return;

    const el = document.querySelector("#nudgeResultCapture"),
      el2 = document.querySelector("#nudgeModalPrint"),
      $this = $(this);

    isBusy = true;
    $this.find('.spinner').show();

    try {
      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'pt',
        format: [1440, 768]
      });

      let canvas = await html2canvas(el, { useCORS: true });
      let imgUrl = await canvas.toDataURL("image/jpeg");
      let imgProps = pdf.getImageProperties(imgUrl);
      let pdfWidth = pdf.internal.pageSize.getWidth();
      let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgUrl, 'JPG', 0, 0, pdfWidth, pdfHeight);

      pdf.addPage();

      canvas = await html2canvas(el2, { useCORS: true });
      imgUrl = await canvas.toDataURL("image/jpeg");
      imgProps = pdf.getImageProperties(imgUrl);
      pdfWidth = pdf.internal.pageSize.getWidth();
      pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgUrl, 'JPG', 0, 0, pdfWidth, pdfHeight);

      pdf.save('nudge.pdf');
    } catch (err) {
      console.log(err);
    } finally {
      isBusy = false;
      $this.find('.spinner').fadeOut(100);
    }
  });

  $(document).on('click', '.nudge-tool .btn-reset', function (e) {
    e.preventDefault();

    nudgeData = {};
    $('#FormNudge').trigger('reset');
    $(".select2").val('').trigger('change');
    window.scrollTo({ top: ($('.nudge-tool__result').offset().top - 120), behavior: 'smooth' });

    setTimeout(function () {
      $('.nudge-tab a').removeClass('active');
      $('.nudge-tab a').first().addClass('active');
      $('.nudge-tool__content').html(nudgeContent);
      $('#containerAgeInfo').fadeOut();
      $('#containerGenderInfo').fadeOut();
      $('.nudge-tool .pattern__base').fadeIn(150);
      $('.nudge-tool .pattern__playbook').fadeOut(100);
      $('.nudge-tool__result').fadeOut(100);
      $('.nudge-tool__form').fadeIn(150);
    }, 100);

  });

  $(document).on('click','.btn-nudge-modal', function (e) {
    e.preventDefault();
    $('.nudge-modal').fadeIn(200);
  });

  $(document).on('click','.nudge-modal__close', function (e) {
    e.preventDefault();
    $('.nudge-modal').fadeOut(100);
  });

})(jQuery);